import i18n from './i18n';

/* WHAT A TICKET'S OWN STATUS IS CALLED — Jay, 2026-09-17, two lines about one screenshot:
   "I would like to use term 'OPEN' not 'Pending' even from Ticket Station", and, circling three
   places at once, "3 Dones are all same or different? It's confusing."

   The honest answer to the second was: two of them are the same and one is not. The DONE card (3)
   and the DONE column (3) are the MANAGER closing the ticket; the legend's Done (35) is the
   RECEIVING TEAM finishing the work while the ticket stays open. One word was doing two jobs on one
   screen, so a reader had no way to tell which was which without being told.

   A ticket carries TWO statuses and they answer different questions. They now use two vocabularies:

     the manager's — where the TICKET is      Open · Closed · Cancelled
     the team's    — where the WORK is        Not started · In Progress · Done · Cancelled

   Open/Closed is a pair; Open/Done was not, and "Closed" is exactly what the manager's Done means —
   `status_done_at` is stamped and nobody but the requester, the project owner or the team manager
   can set it. After the rename "Done" appears once on the page and it belongs to the team, which
   answers Jay's question by construction instead of by a footnote under the chart.

   ONLY THE LABEL MOVES. `task_status_name` is the stored VALUE: the dim row, every ticket's
   `status`, the filter that compares it, the Ticket Station cards and every count in the report key
   off it, so renaming the key would be renaming the data. The same split as `role_key`/`role_name`
   and `team_key`/`team_name`, and the same one the report has used for Open since earlier today.

   THE TEAM'S FOUR WORDS ARE NOT RENAMED. "Done" is the button that team presses on the public reply
   page; the report, the grid's Assignee reply column and that page have to keep saying one word for
   one act. Their "Cancelled" still reads like the manager's, which is the one overlap left — it is
   painted purple against the manager's grey and sits under a legend that names whose answer it is.

   ENGLISH ONLY until 2026-10-21, like the values it replaces; since then the label reads the reader's
   language (below), through the same keys as the two Ticket Station KPI cards (`st.tkPending` / `st.tkDone`). */
export const TASK_STATUS_LABEL = { Pending: 'Open', Done: 'Closed', Cancelled: 'Cancelled' };
/* In the reader's language since 2026-10-21: the same three words the Ticket Station cards and the report already
   carry in all four (st.tk*), so the pill, the dropdown and the cards cannot name one status two ways. Still only the
   LABEL — every caller compares the stored value. */
const TASK_STATUS_KEY = { Pending: 'st.tkPending', Done: 'st.tkDone', Cancelled: 'st.tkCancelled' };

export const taskStatusLabel = (value) => {
  const v = String(value == null ? '' : value).trim();
  /* An unknown word is printed as it is. A status this table has never heard of is still a fact
     about the ticket, and blanking it would read as "no status", which is a different one. */
  if (TASK_STATUS_KEY[v]) return i18n.t(TASK_STATUS_KEY[v]);
  return TASK_STATUS_LABEL[v] || v;
};
